import { NavigationGuardWithThis } from 'vue-router';

const before: NavigationGuardWithThis<undefined> = (to, from, next) => {
    // todo: before hooks
    return false;
};

export default before;
